import { createAppSelector } from 'store/hooks';

export const modalSelector = createAppSelector(
  [
    (state) => state.modal.logQuantity.areLogDataValid,
    (state) => state.modal.note.isCurrentActivityPlaying,
    (state) => state.setting.currentPlayingActivity,
    (state) => state.setting.isShowLibraryMoreOptionsOpened
  ],
  (
    areLogDataValid,
    isCurrentActivityPlaying,
    currentPlayingActivity,
    isShowLibraryMoreOptionsOpened
  ) => {
    return {
      areLogDataValid,
      isCurrentActivityPlaying,
      currentPlayingActivity,
      isShowLibraryMoreOptionsOpened
    };
  }
);

export const focusSummaryEditModalSelector = createAppSelector(
  [
    (state) => state.modal.focusSummaryEdit.showFocusSummaryEdit,
    (state) => state.modal.focusSummaryEdit.focusSummary,
    (state) => state.modal.focusSummaryEdit.mode,
    (state) => state.user.focus_modes,
    (state) => state.user.weeklyFocusBlockSummary
  ],
  (
    showFocusSummaryEdit,
    focusSummary,
    mode,
    focusModes,
    weeklyFocusBlockSummary
  ) => {
    return {
      showFocusSummaryEdit,
      focusSummary,
      mode,
      focusModes,
      weeklyFocusBlockSummary
    };
  }
);
